import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import dayjs from "dayjs";

import * as Common from "../commons/common";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";

import CustomDatePicker from "./CustomDatePicker";

function ModalRentPeakSeason({
    open,
    rentPeakSeason,
    onChangedOpen,
    onChangeRentPeakSeasonInfo,
}: {
    open: boolean;
    rentPeakSeason?: Types.RentPeakSeasonDto;
    onChangedOpen: (open: boolean) => void;
    onChangeRentPeakSeasonInfo?: (type: "register" | "update", value: any) => void;
}) {
    const [form] = Form.useForm();
    const [currentRentPeakSeason, setCurrentRentPeakSeason] = useState<Types.RentPeakSeasonDto>();

    useEffect(() => {
        form.resetFields();
    }, [open]);

    useEffect(() => {
        if (!rentPeakSeason) return;

        setCurrentRentPeakSeason(rentPeakSeason);

        form.setFieldsValue({
            ...rentPeakSeason,
            startDate: dayjs(rentPeakSeason.startDate),
            endDate: dayjs(rentPeakSeason.endDate),
        });
    }, [rentPeakSeason]);

    const handleClose = () => {
        onChangedOpen(false);
    };

    const onFinish = (values: any) => {
        if (values.startDate > values.endDate) {
            Modal.error({
                title: "적용일 오류",
                content: "적용 시작일은 적용 종료일 전으로 설정할 수 없습니다.",
                okText: "확인",
                onOk() {},
                centered: true,
            });
            return;
        }

        onChangedOpen(false);

        values.startDate = Utils.utcToLocalTime(String(values.startDate).valueOf(), Common.FORMAT_DATE);
        values.endDate = Utils.utcToLocalTime(String(values.endDate).valueOf(), Common.FORMAT_DATE);

        const tempData = { ...currentRentPeakSeason, ...values };
        console.log("tempData", tempData);

        onChangeRentPeakSeasonInfo && onChangeRentPeakSeasonInfo(currentRentPeakSeason ? "update" : "register", tempData);
    };

    return (
        <Modal
            centered
            forceRender
            closable={false}
            className="login"
            open={open}
            title={currentRentPeakSeason ? "성수기 수정" : "성수기 추가"}
            onOk={handleClose}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button key="setPassword" type="primary" onClick={() => form.submit()}>
                    {currentRentPeakSeason ? "수정" : "추가"}
                </Button>,
            ]}
        >
            <Form form={form} onFinish={onFinish} className="modalRentPeakSeason">
                <Form.Item name="startDate" label="적용 시작일" rules={[{ type: "object", required: true, message: "적용 시작일을 선택하세요." }]}>
                    <CustomDatePicker placeholder="시작일" allowClear={false} />
                </Form.Item>
                <Form.Item name="endDate" label="적용 종료일" rules={[{ type: "object", required: true, message: "적용 종료일을 선택하세요." }]}>
                    <CustomDatePicker placeholder="종료일" allowClear={false} />
                </Form.Item>
            </Form>
        </Modal>
    );
}

export default ModalRentPeakSeason;
